import { Link } from "react-router-dom";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

const SIZE = 20;
const HIPOTENUSE_FACTOR = 1.4142;
const LINK_HEIGHT = HIPOTENUSE_FACTOR * SIZE;

interface LeftArrowProps {
  color: string;
}

export const StyledLink = styled(Link)`
  height: ${LINK_HEIGHT}px;
  float: left;
  position: absolute;
  transform: translateX(-50px);

  @media (max-width: ${breakpoints.lg}) {
    position: unset;
    transform: unset;
    margin-right: 20px;
  }
`;

export const LeftArrow = styled.div<LeftArrowProps>`
  border-top: 4px solid ${({ color }) => color};
  border-left: 4px solid ${({ color }) => color};
  height: ${SIZE}px;
  width: ${SIZE}px;
  transform: translate(4px, -3px) rotate(-45deg);
  transform-origin: right;
  box-sizing: border-box;
`;
